import { AiCoach_Action as AiCoachAction } from '__generated__/graphql-types';

import _t from 'i18n!nls/learning-assistant-chat-ai';

export const MESSAGE_SENDER = {
  CLIENT: 'USER',
  RESPONSE: 'SYSTEM',
} as const;

export const MESSAGES_TYPES = {
  TEXT: 'text',
  SNIPPET: {
    LINK: 'snippet',
  },
  CUSTOM_COMPONENT: 'component',
};

export const AICOACH_FEEDBACK: { like: 'LIKE'; dislike: 'DISLIKE'; unset: 'UNSET' } = {
  like: 'LIKE',
  dislike: 'DISLIKE',
  unset: 'UNSET',
};

export const getErrorMessageText = () => _t('Sorry, there was an error responding. Please try your message again.');

export const ACTIVE_COURSERA_COACH_SESSION_STORAGE_KEY = 'activeCourseraCoachSessionId';

/**
 * These actions have specialized FE business logic associated with them
 * and are not intended for the user to interact with manually.
 * */
export const SYSTEM_RECOMMENDED_ACTIONS: AiCoachAction[] = [AiCoachAction.CoachItemSummary];

export const DYNAMIC_PROMPT_ACTION = {
  LEARNING_RECAP: 'LEARNING_RECAP',
  TRY1_QUESTION_CHALLENGE: 'TRY1_QUESTION_CHALLENGE',
};
